import {
  FaCamera,
  FaCloud,
  FaCompass,
  FaLock,
  FaMicrophone,
  FaStore,
  FaTrash,
  FaUser,
  FaWifi,
} from "react-icons/fa";

const ICONS = {
  allowCamera: FaCamera,
  allowScreenShot: FaCamera,
  allowSafari: FaCompass,
  allowAppInstallation: FaStore,
  allowUIAppInstallation: FaStore,
  allowCloudBackup: FaCloud,
  allowCloudDocumentSync: FaCloud,
  allowCloudPrivateRelay: FaCloud,
  allowAssistant: FaMicrophone,
  allowPasscodeModification: FaLock,
  allowAccountModification: FaUser,
  allowEraseContentAndSettings: FaTrash,
  allowAirDrop: FaWifi,
  forceWiFiPowerOn: FaWifi,
  forceWiFiToAllowedNetworksOnly: FaWifi,
};

export default function FieldIcon({ field }) {
  const Icon = ICONS[field.key];
  if (!Icon) return null;
  const description = field.appleContent || field.hint || field.label;
  return <Icon className="profile-field-icon" title={description} aria-label={description} />;
}
